<template>
    <div>
        <input
            id="my-modal"
            v-model="modelVisible"
            type="checkbox"
            class="modal-toggle" >
        <label
            for="my-modal"
            class="modal cursor-pointer">
            <label
                class="modal-box relative"
                for="">
                <h3>
                    {{ label }}!
                </h3>
                <div class="relative">
                    <image-cropper
                        ref="cropper"
                        style="max-height: 1000px"
                        :src="imageSrc"
                        :default-size="type !== 'stencil' ? stencilSize : null"
                        :stencil-size="type === 'stencil' ? stencilSize : null"
                        :auto-zoom="true"
                        :image-restriction="type === 'stencil' ? 'stencil' : null"
                        @change="change"
                        @ready="onLoadedImage" />
                    <div class="absolute bottom-0 flex px-2 py-3">
                        <div
                            title="Flip Horizontal"
                            class="mx-3 cursor-pointer"
                            @click="flip(true, false)">
                            <svg
                                id="Layer_1"
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink"
                                x="0px"
                                y="0px"
                                width="16px"
                                height="16px"
                                viewBox="0 0 16 16"
                                enable-background="new 0 0 16 16"
                                xml:space="preserve">
                                <line
                                    fill="#FFFFFF"
                                    stroke="#FFFFFF"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-miterlimit="10"
                                    x1="8"
                                    y1="1"
                                    x2="8"
                                    y2="14.9" />
                                <g>
                                    <g>
                                        <line
                                            fill="none"
                                            stroke="#FFFFFF"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            x1="11.5"
                                            y1="12.8"
                                            x2="12"
                                            y2="12.8" />
                                        <polyline
                                            fill="none"
                                            stroke="#FFFFFF"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            points="14.2,12.8
			14.7,12.8 14.7,12.3 		" />

                                        <line
                                            fill="none"
                                            stroke="#FFFFFF"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-dasharray="0.8091,2.4273"
                                            x1="14.7"
                                            y1="9.9"
                                            x2="14.7"
                                            y2="4.6" />
                                        <polyline
                                            fill="none"
                                            stroke="#FFFFFF"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            points="14.7,3.4
			14.7,2.9 14.2,2.9 		" />

                                        <line
                                            fill="none"
                                            stroke="#FFFFFF"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            x1="12"
                                            y1="2.9"
                                            x2="11.5"
                                            y2="2.9" />
                                    </g>
                                </g>
                                <polyline
                                    fill="none"
                                    stroke="#FFFFFF"
                                    stroke-width="1.5"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    points="4.5,2.9
	1.3,2.9 1.3,12.8 4.5,12.8 " />
                            </svg>
                        </div>
                        <div
                            title="Flip Vertical"
                            class="mx-3 cursor-pointer"
                            @click="flip(false, true)">
                            <svg
                                id="Layer_1"
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink"
                                x="0px"
                                y="0px"
                                width="16px"
                                height="16px"
                                viewBox="0 0 16 16"
                                enable-background="new 0 0 16 16"
                                xml:space="preserve">
                                <line
                                    fill="#FFFFFF"
                                    stroke="#FFFFFF"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-miterlimit="10"
                                    x1="15"
                                    y1="8"
                                    x2="1"
                                    y2="8" />
                                <g>
                                    <g>
                                        <line
                                            fill="none"
                                            stroke="#FFFFFF"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            x1="3.2"
                                            y1="11.5"
                                            x2="3.2"
                                            y2="12" />
                                        <polyline
                                            fill="none"
                                            stroke="#FFFFFF"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            points="3.2,14.2
			3.2,14.7 3.7,14.7 		" />

                                        <line
                                            fill="none"
                                            stroke="#FFFFFF"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-dasharray="0.8091,2.4273"
                                            x1="6.1"
                                            y1="14.7"
                                            x2="11.4"
                                            y2="14.7" />
                                        <polyline
                                            fill="none"
                                            stroke="#FFFFFF"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            points="12.6,14.7
			13.1,14.7 13.1,14.2 		" />

                                        <line
                                            fill="none"
                                            stroke="#FFFFFF"
                                            stroke-width="1.5"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            x1="13.1"
                                            y1="12"
                                            x2="13.1"
                                            y2="11.5" />
                                    </g>
                                </g>
                                <polyline
                                    fill="none"
                                    stroke="#FFFFFF"
                                    stroke-width="1.5"
                                    stroke-linejoin="round"
                                    stroke-miterlimit="10"
                                    points="13.1,4.4
	13.1,1.3 3.2,1.3 3.2,4.4 " />
                            </svg>
                        </div>
                        <div
                            title="Rotate Clockwise"
                            class="mx-3 cursor-pointer"
                            @click="rotate(90)">
                            <svg
                                id="Layer_1"
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink"
                                x="0px"
                                y="0px"
                                width="16px"
                                height="16px"
                                viewBox="0 0 16 16"
                                enable-background="new 0 0 16 16"
                                xml:space="preserve">
                                <g enable-background="new    ">
                                    <path
                                        fill="#FFFFFF"
                                        d="M1.5,8c0-3.7,3-6.5,6.5-6.5c1.7,0,3.3,0.7,4.5,1.8l1.1-1.1c0.1-0.1,0.4-0.1,0.6-0.1
		c0.1,0.1,0.3,0.3,0.3,0.6v3.8c0,0.3-0.3,0.6-0.6,0.6h-3.8C10,6.9,9.8,6.7,9.7,6.6C9.6,6.4,9.7,6.2,9.8,6L11,4.9
		C10.1,4,9.1,3.6,8,3.6c-2.4,0-4.4,2-4.4,4.4s2,4.4,4.4,4.4c1.4,0,2.5-0.6,3.4-1.7l0.1-0.1c0.1,0,0.1,0,0.3,0.1l1.1,1.1
		c0.1,0.1,0.1,0.3,0,0.4c-1.1,1.4-3,2.3-4.9,2.3C4.3,14.5,1.5,11.7,1.5,8z" />
                                </g>
                            </svg>
                        </div>
                        <div
                            title="Rotate Counter-Clockwise"
                            class="mx-3 cursor-pointer"
                            @click="rotate(-90)">
                            <svg
                                id="Layer_1"
                                version="1.1"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink"
                                x="0px"
                                y="0px"
                                width="16px"
                                height="16px"
                                viewBox="0 0 16 16"
                                enable-background="new 0 0 16 16"
                                xml:space="preserve">
                                <g enable-background="new    ">
                                    <path
                                        fill="#FFFFFF"
                                        d="M8,14.5c-2,0-3.8-0.8-5.1-2.4c-0.1-0.1-0.1-0.3,0-0.4l1.1-1.1c0,0,0.1-0.1,0.3-0.1c0.1,0,0.1,0,0.1,0.1
		c1,1.3,2.1,1.8,3.5,1.8c2.4,0,4.4-2,4.4-4.4s-2-4.4-4.4-4.4c-1.1,0-2.1,0.4-3,1.1l1.1,1.1c0.1,0.3,0.3,0.4,0.1,0.7
		C6.2,6.7,6.1,6.9,5.9,6.9H2c-0.3,0-0.6-0.3-0.6-0.6V2.5c0-0.3,0.1-0.4,0.3-0.6c0.1-0.1,0.4,0,0.6,0.1l1.1,1.1
		c1.3-1.1,2.8-1.8,4.5-1.8c3.7,0,6.5,3,6.5,6.5S11.7,14.5,8,14.5z" />
                                </g>
                            </svg>
                        </div>
                        <div
                            title="Zoom in"
                            class="mx-3 cursor-pointer"
                            @click="zoom(2)">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16">
                                <path
                                    fill="#FFF"
                                    d="M14.8 16c-.3 0-.6-.1-.9-.4l-3.3-3.3c-1.1.8-2.5 1.2-3.8 1.2-3.8 0-6.8-3-6.8-6.7C0 3 3 0 6.8 0c3.7 0 6.8 3 6.8 6.8 0 1.4-.4 2.7-1.2 3.8l3.3 3.3c.2.2.4.5.4.9-.1.7-.6 1.2-1.3 1.2zm-8-13.5c-2.4 0-4.3 1.9-4.3 4.3s1.9 4.3 4.3 4.3 4.3-1.9 4.3-4.3-2-4.3-4.3-4.3z" />
                                <path
                                    fill="#FFF"
                                    d="M9 5.8H7.8V4.5c0-.2-.1-.3-.3-.3H6.1c-.2 0-.3.1-.3.3v1.3H4.5c-.2 0-.3.1-.3.3v1.4c0 .2.1.3.3.3h1.3V9c0 .2.1.3.3.3h1.4c.2 0 .3-.1.3-.3V7.8H9c.2 0 .3-.1.3-.3V6.1c0-.2-.1-.3-.3-.3z" />
                            </svg>
                        </div>
                        <div
                            title="Zoom out"
                            class="mx-3 cursor-pointer"
                            @click="zoom(0.5)">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16">
                                <path
                                    fill="#FFF"
                                    d="M14.8 16c-.3 0-.6-.1-.9-.4l-3.3-3.3c-1.1.8-2.5 1.2-3.8 1.2-3.8 0-6.8-3-6.8-6.7C0 3 3 0 6.8 0c3.7 0 6.8 3 6.8 6.8 0 1.4-.4 2.7-1.2 3.8l3.3 3.3c.2.2.4.5.4.9-.1.7-.6 1.2-1.3 1.2zm-8-13.5c-2.4 0-4.3 1.9-4.3 4.3s1.9 4.3 4.3 4.3 4.3-1.9 4.3-4.3-2-4.3-4.3-4.3z" />
                                <path
                                    fill="#FFF"
                                    d="M9.3 7.5c0 .2-.1.3-.3.3H4.5c-.2 0-.3-.1-.3-.3V6.1c0-.2.1-.3.3-.3H9c.2 0 .3.1.3.3v1.4z" />
                            </svg>
                        </div>
                    </div>
                </div>
                <div class="modal-action">
                    <!-- thay đổi hiệu ứng loading -->
                    <span
                        class="btn btn-success"
                        :class="{ loading: uploading }"
                        @click="upload">
                        {{ $t('labels.update') }}
                    </span>
                    <label
                        for="my-modal"
                        class="btn">
                        {{ $t('labels.close') }}
                    </label>
                </div>
            </label>
        </label>
    </div>
</template>

<script setup>
import { Cropper as ImageCropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'

const props = defineProps({
  label: {
    type: String,
    default: () => $t('labels.chooseYourAvatar')
  },
  api: {
    type: Object,
    default: () => ({
      method: 'put',
      url: '/auth/company-user/change-avatar'
    })
  },
  stencilSize: {
    type: Object,
    default: () => ({
      width: 280,
      height: 280
    })
  },
  stencilProps: {
    type: Object,
    default: () => ({
      handlers: {},
      movable: false,
      resizable: false
    })
  },
  type: {
    type: String,
    default: 'stencil'
  },
  successLabel: {
    type: String,
    default: ''
  }
})

const { api, successLabel } = toRefs(props)

const modelVisible = ref(false)
const input = ref(null)
const cropper = ref(null)
const imageSrc = ref('')
const uploading = ref(false)
const emits = defineEmits(['change', 'upload-success', 'upload-fail'])

const open = () => {
  if (input?.value) {
    input.value.remove()
  }
  input.value = document.createElement('input')
  input.value.type = 'file'
  input.value.accept = 'image/*'
  input.value.addEventListener('change', fileChange)
  input.value.click()
}
watch(
  () => modelVisible.value,
  (val) => {
    if (!val) {
      input.value = ''
    }
  }
)

const onLoadedImage = () => {
  nextTick(() => {
    modelVisible.value = true
  })
}

const flip = (x, y) => {
  cropper.value.flip(x, y)
}

const rotate = (angle) => {
  cropper.value.rotate(angle)
}

const zoom = (val) => {
  cropper.value.zoom(val)
}

const download = () => {
  const result = cropper.value.getResult().canvas.toDataURL()
  const newTab = window.open()
  newTab.document.body.innerHTML = `<img src="${result}"></img>`
}

const change = (data) => {
  emits('change', data)
}

const fileChange = (e) => {
  if (e.target.files.length) {
    const file = e.target.files[0]
    cropImage(file)
  }
}

const cropImage = (file) => {
  imageSrc.value = URL.createObjectURL(file)
}

const upload = async () => {
  if (uploading.value) {
    return
  }

  if (!cropper.value.getResult()) {
    process.client && $toast().error('Không lấy được ảnh đã chọn')
    return
  }
  const data = new FormData()
  try {
    const imageData = cropper.value.getResult().canvas.toDataURL()
    const blobBin = atob(imageData.split(',')[1])
    const array = []
    for (let i = 0; i < blobBin.length; i++) {
      array.push(blobBin.charCodeAt(i))
    }
    const file = new Blob([new Uint8Array(array)], { type: 'image/png' })

    data.append('img', file)
  } catch (e) {
    process.client && $toast().error('Không lấy được ảnh đã chọn')
    return
  }
  uploading.value = true

  const res = await $api(api.value, { body: data })
  const resData = $lodash.get(res, 'data.value')

  if (resData?.success) {
    process.client && $toast().success(successLabel.value || 'Thay đổi ảnh đại diện thành công')
    emits('upload-success', resData.data)
    uploading.value = false
    modelVisible.value = false
  } else {
    uploading.value = false
  }
}

defineExpose({
  open
})
</script>
